import { Report } from '../../../../types/reports'

export enum DARIO_REPORTS_ACTION_TYPES {
	SET_REPORTS = 'SET_REPORTS',
	DELETE_REPORT = 'DELETE_REPORT',
	ADD_REPORT = 'ADD_REPORT',
	SET_STATUSES = 'SET_STATUSES',
	SET_TYPES = 'SET_TYPES',
	SET_NAME = 'SET_NAME',
	SET_REPORT_PERIOD = 'SET_REPORT_PERIOD',
	SET_REPORT_DATE = 'SET_REPORT_DATE',
	RESET = 'RESET',
}

interface ReportsListAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_REPORTS
	payload: Array<Report>
}
interface DeleteReportAction {
	type: DARIO_REPORTS_ACTION_TYPES.DELETE_REPORT
	payload: string
}
interface AddReportAction {
	type: DARIO_REPORTS_ACTION_TYPES.ADD_REPORT
	payload: Report
}
interface SetStatusesAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_STATUSES
	payload: Array<string>
}
interface SetTypesAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_TYPES
	payload: Array<string>
}
interface SetNameAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_NAME
	payload: string
}
interface SetReportPeriodAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_REPORT_PERIOD
	payload: string
}
interface SetReportDateAction {
	type: DARIO_REPORTS_ACTION_TYPES.SET_REPORT_DATE
	payload: number
}
interface ResetAction {
	type: DARIO_REPORTS_ACTION_TYPES.RESET
}

export interface ReportsState {
	reports: Array<Report>
	// filters
	statuses: Array<string>
	types: Array<string>
	name: string
	reportPeriod: string
	reportDate: number | null
}

const initialState: ReportsState = {
	reports: [],
	statuses: [],
	types: [],
	name: '',
	reportPeriod: '',
	reportDate: null,
}

type reportActions =
	| ReportsListAction
	| DeleteReportAction
	| AddReportAction
	| SetStatusesAction
	| SetTypesAction
	| SetNameAction
	| ResetAction
	| SetReportPeriodAction
	| SetReportDateAction

export default (state = initialState, action: reportActions): ReportsState => {
	switch (action.type) {
		case DARIO_REPORTS_ACTION_TYPES.SET_REPORTS: {
			return {
				...state,
				reports: action.payload || [],
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.DELETE_REPORT: {
			const index = state.reports.findIndex(r => r.id === action.payload)
			if (!~index) return state

			const reports = state.reports
			reports.splice(index, 1)
			return {
				...state,
				reports,
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.ADD_REPORT: {
			return {
				...state,
				reports: [...state.reports, action.payload],
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.SET_STATUSES: {
			return {
				...state,
				statuses: [...action.payload],
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.SET_TYPES: {
			return {
				...state,
				types: [...action.payload],
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.SET_NAME: {
			return {
				...state,
				name: action.payload,
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.SET_REPORT_PERIOD: {
			return {
				...state,
				reportPeriod: action.payload,
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.SET_REPORT_DATE: {
			return {
				...state,
				reportDate: action.payload,
			}
		}

		case DARIO_REPORTS_ACTION_TYPES.RESET: {
			return {
				...state,
				statuses: [],
				types: [],
				name: '',
				reportPeriod: '',
				reportDate: null,
			}
		}

		default: {
			return state
		}
	}
}
